import pkg from '../../package.json';
import persistedVersion from './buildVersion.json';

// The release number is the persisted Charlie 1.75 change counter. The commit
// is the unambiguous identity of the artifact actually built by Vercel.
const persistedRelease = Number.isInteger(persistedVersion.landing)
  ? `1.75.${String(persistedVersion.landing).padStart(3, '0')}`
  : pkg.version;
export const APP_VERSION = process.env.REACT_APP_GIT_VERSION || persistedRelease;
export const APP_GIT_SHA = process.env.REACT_APP_GIT_SHA || 'local';
export const APP_BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';
// The user-facing release tracker is intentionally compact: the persisted
// 1.75.xxx landing number is the operational version. Git SHA remains
// available to diagnostics, but is not part of the menu/sidebar badge.
export const APP_BUILD_LABEL = `v${APP_VERSION}`;
export const APP_BUILD_TITLE = APP_BUILD_TIME
  ? `Charlie ${APP_BUILD_LABEL} · built ${APP_BUILD_TIME}`
  : `Charlie ${APP_BUILD_LABEL} · local build`;
